import { render, staticRenderFns } from "./SerialListPage.vue?vue&type=template&id=96794f22&"
import script from "./SerialListPage.vue?vue&type=script&lang=js&"
export * from "./SerialListPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports